import type { PaginationRecordRangeProps } from '../../types/propType';
import styles from './PaginationRecordRange.module.scss';

const PaginationRecordRange = ({
  currentPage,
  rowsPerPage,
  totalRecords,
  startRecordIndex,
  endRecordIndex,
  formatPaginationCallback,
}: PaginationRecordRangeProps) => (
  <div className={styles['pagination-record-range']}>
    {formatPaginationCallback ? (
      formatPaginationCallback({
        recordStartIndex: startRecordIndex(currentPage, rowsPerPage) + 1,
        recordEndIndex: endRecordIndex(currentPage, rowsPerPage) || rowsPerPage,
        totalRecords,
        currentPage: currentPage + 1,
        rowsPerPage,
      })
    ) : (
      <>
        {startRecordIndex(currentPage, rowsPerPage) + 1}-{endRecordIndex(currentPage, rowsPerPage)} of {totalRecords}
      </>
    )}
  </div>
);

export default PaginationRecordRange;
